<div class="bg-primary-100 lg:pt-12">
  <div class="max-w-4xl mx-auto px-4 py-12 lg:py-20">
    <div class="flex flex-col lg:flex-row items-center">
      <div class="flex-1 flex flex-col relative">
        <picture
          class="hidden lg:flex flex-col w-full scale-150 translate-x-1/3"
        >
          <img
            [ngSrc]="baseUrl + '/assets/imgs/download/phone.png'"
            width="815"
            height="648"
            class="object-fit"
            alt="APP Mobo"
          />
        </picture>
      </div>

      <div class="flex-1 flex flex-col relative">
        <div
          class="text-justify text-primary-800 text-5xl font-bold leading-10 tracking-tight mb-10"
        >
          Descontos<br />todos os dias!
        </div>
        <picture class="hidden lg:flex flex-col w-full relative">
          <img
            [ngSrc]="baseUrl + '/assets/imgs/download/download.png'"
            width="474"
            height="337"
            class="object-fit"
            alt="Download"
          />
        </picture>
        <div class="absolute hidden lg:flex items-center gap-8 -right-12 top-1/2">
          <a
            href="https://apps.apple.com/br/app/mobo-cupons-para-restaurantes/id454983754"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              [ngSrc]="baseUrl + '/assets/imgs/icons/app-store.png'"
              alt="App Store"
              height="40"
              width="40"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=br.com.mobo.cupons&hl=pt_BR"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              [ngSrc]="baseUrl + '/assets/imgs/icons/play-store.png'"
              alt="Play Store"
              height="40"
              width="40"
            />
          </a>
        </div>
      </div>
      <a
        href="https://mobocupons.page.link/mobocupons"
        target="_blank"
        rel="noopener noreferrer"
        class="flex lg:hidden text-justify text-white text-3xl font-bold leading-10 tracking-tight px-10 py-4 bg-primary-500 rounded-lg shadow-xl mb-10"
      >
        BAIXE AGORA
      </a>
    </div>
  </div>
</div>
<div class="bg-primary-100">
  <div class="max-w-6xl mx-auto px-4 pb-20 lg:py-20 -mb-32">
    <div class="grid grid-cols-1 lg:grid-cols-3">
      <div
        class="flex lg:flex-col justify-start items-center mb-24 gap-6 lg:gap-10"
      >
        <!-- <div class="hidden lg:block w-48 lg:h-48 bg-primary-500 rounded-full border-4 border-primary-100"></div> -->
        <div class="text-center text-primary-500 text-7xl font-bold leading-10">
          1
        </div>
        <div
          class="lg:text-center text-primary-800 text-xl lg:text-2xl font-medium"
        >
          Baixe o app e <br class="hidden lg:block" />crie a sua conta
        </div>
      </div>
      <div
        class="flex lg:flex-col justify-start items-center mb-24 gap-6 lg:gap-10"
      >
        <!-- <div class="hidden lg:block w-48 lg:h-48 bg-primary-500 rounded-full border-4 border-primary-100"></div> -->
        <div class="text-center text-primary-500 text-7xl font-bold leading-10">
          2
        </div>
        <div
          class="lg:text-center text-primary-800 text-xl lg:text-2xl font-medium"
        >
          Baixe o cupom <br class="hidden lg:block" />desejado
        </div>
      </div>
      <div class="flex lg:flex-col justify-start items-center gap-6 lg:gap-10">
        <!-- <div class="hidden lg:block w-48 lg:h-48 bg-primary-500 rounded-full border-4 border-primary-100"></div> -->
        <div class="text-center text-primary-500 text-7xl font-bold leading-10">
          3
        </div>
        <div
          class="lg:text-center text-primary-800 text-xl lg:text-2xl font-medium"
        >
          Apresente o <br class="hidden lg:block" />código do cupom na
          <br class="hidden lg:block" />hora do pagamento
        </div>
      </div>
    </div>
  </div>
</div>
